<template>
    <div class="claim">
        <SearchForm
        :searchForm="initParam"
        :searchFormTemp="searchFormTemp"
        @normalSearch="normalSearch"
        @normalResetQuery="normalResetQuery"
        :labelWidth="'80px'"
        >
            <div slot="selectTree">
                <OrganTree v-model="initParam.param.enterpriseId" :data="organData" ></OrganTree>
            </div>
        </SearchForm>
        <Table :data="listData" :options="listDataOptions" align="center">
            <template v-slot:index>
            <el-table-column type="index" label="序号" min-width="50" align="center"></el-table-column>
            </template>  
            <el-table-column slot="operate" label="操作">
            <template slot-scope="scope">
                <el-button type="text" @click="claimView(scope.row)">下载</el-button>
              
            </template>
            </el-table-column>
        </Table>
        <Pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :pageData="initParam"
            :total="total"
        ></Pagination>
    </div>
</template>
<script>
import Pagination from '@/components/layouts/Pagination';
import Table from '@/components/layouts/table';
import SearchForm from '@/components/layouts/SearchForm';
import OrganTree from '@/components/layouts/selectTree';
import { myMixin } from '@/mixins/index';
import { queryOrgList,queryDic } from '@/api/BSC';
import {getDicList,} from '@/config/tool.js'
import {claimQueryList ,claimDel,fileUpload,claimAdd,exportClaim ,downloadTemplate} from '@/api/claim'
export default {
    components:{
        Pagination,
        Table,
        SearchForm,
        OrganTree
    },
    mixins: [myMixin],
    data(){
        return{
            dicArr: ['bbc.fileDimension'],
            initParam:{
                pageNum: 1,
                pageSize: 10,
                param: { 
                    enterpriseId:'',
                    dimension:'',
                    period:''
                }, 
            },
            searchFormTemp: [                            
                {
                lable: '数据维度',
                name: 'dimension',
                type: 'select',
                list: [],
                },
                {
                lable: '统计期次',
                name: 'period',
                type: 'datePicker',
                itemType:'year',
                option:{
                    disabledDate: date => {
                    return date && date.valueOf() > new Date()
                    }
                }
                },
            ],
            organData:[],
            total:0,
            listData:[],
            listDataOptions: [
                { prop: 'enterpriseName', label: '企业名称' },
                { prop: 'enterpriseId', label: '企业编码' },
                { prop: 'dimension', label: '数据维度',dic:'bbc.fileDimension' },
                { prop: 'period', label: '统计期次' },
            ],
        }
    },
    methods:{
        async init() {
        await this.getDics()
        this.queryData();
        },
        async queryData(bool = true) {
        // 默认将当前页数归1
        if (bool) this.initParam.pageNum = 1;
        let res = await claimQueryList(this.initParam);
        this.listData = res.list;
        this.total = res.total;
        },
        //数据维度字典
        async getDics(){
            let result=this.$store.state.dicMap['bbc.fileDimension']?this.$store.state.dicMap['bbc.fileDimension']: await queryDic({ dicCode:"bbc.fileDimension"})

            this.searchFormTemp[0].list=result.map((item,index)=>{
                return { dicItemName: item.dicItemName, dicItemCode: item.dicItemCode }
            })
        },
        claimView(obj){
            // downloadTemplate({isOnline:false,fileId:obj.fileId,target:0})
            window.open(obj.absolutePath)
        }
    },
}
</script>
<style lang="less" scoped>
.claim{
    padding:33px;
}
</style>
